<!-- 展示用户个人信息-->
<template>
  <el-dialog title='用户信息展示' :visible.sync="visible" :beforeClose="close" custom-class="profileDialog">
    <div class="app-container">
      <el-row :gutter="20">
        <el-col :span="6" :xs="24">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>个人信息</span>
            </div>
            <div>
              <div class="text-center">
                <userAvatar :user="user" />
              </div>
              <ul class="list-group list-group-striped">
                <li class="list-group-item">
                  <i class="el-icon-user-solid">用户名称</i>
                  <div class="pull-right">{{ user.username }}</div>
                </li>
                <li class="list-group-item">
                  <i class="el-icon-mobile-phone">手机号码</i>
                  <div class="pull-right">{{ user.phonenumber }}</div>
                </li>
                <li class="list-group-item">
                  <i class="el-icon-message">用户邮箱</i>
                  <div class="pull-right">{{ user.email }}</div>
                </li>
                <li class="list-group-item">
                  <i class="el-icon-s-custom" >所属角色</i>
                  <div class="pull-right">{{ roleNames }}</div>
                </li>
                <li class="list-group-item">
                  <i class="el-icon-date" >创建日期 </i>
                  <div class="pull-right">{{ user.createTime }}</div>
                </li>
              </ul>
            </div>
          </el-card>
        </el-col>
        <el-col :span="18" :xs="24">
          <el-card>
            <div slot="header" class="clearfix">
              <span>基本资料</span>
            </div>
            <el-tabs v-model="activeTab">
              <el-tab-pane label="基本资料" name="userinfo">
                <userInfo :user="user" :cancel="close"/>
              </el-tab-pane>
              <el-tab-pane label="修改密码" name="resetPwd">
                <resetPwd :cancel="close"/>
              </el-tab-pane>
            </el-tabs>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </el-dialog>
</template>

<script>
import userAvatar from "./userAvatar";
import userInfo from "./userInfo";
import resetPwd from "./resetPwd";
import { getInfo } from "@/api/login";

export default {
  name: "Profile",
  components: { userAvatar, userInfo, resetPwd },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    visible(n) {
      if (n) {
        this.getUser();
      }
    }
  },
  data() {
    return {
      user: {},
      roleNames: '',
      activeTab: "userinfo"
    };
  },
  created() {
    this.getUser();
  },
  methods: {
    getUser() {
      getInfo().then(response => {
        this.user = response.data;
        this.roleNames = response.data.roleNames.join(',');
      });
    },
    close() {
      this.user = {};
      this.roleNames = {};
      this.$emit('close')
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss">
  .profileDialog {
    width: 90% !important;
  }
  .app-container{
    .list-group{
      display: flex;
      flex-direction: column;
      margin-top: 20px;
      .list-group-item{
        flex: 1;
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #e7eaec;
        padding: 11px 0px;
        font-size: 13px;
        &:first-child{
          border-top: 1px solid #e7eaec;
        }
        .pull-right{
          color: #8c8c8c;
        }
      }
    }
  }
</style>
